<div class="breadcrumb-container">
    <div
      *ngFor="let item of breadcrumbs; let i = index"
      class="breadcrumb-container__item"
      [ngClass]="{
        'actual': i === breadcrumbs.length -1,
        'clickable': i !== breadcrumbs.length -1
      }"
      (click)="onBreadcrumbClick(item, i)"
    >
        {{ item.label }}
        <div *ngIf="i !== breadcrumbs.length -1" class="breadcrumb-container__item__icon">></div>
    </div>
</div>
